import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: 55px 515px 40px;
`;

export const TitleContainer = styled.div`
	display: grid;
	align-items: center;
	height: 55px;

	h1 {
		color: #5082c2;
		font-weight: 600;
		font-size: 16px;
		text-align: center;
	}
`;

export const ContentContainer = styled.div`
	padding: 10px 10px 10px 0;
	max-height: 500px;
	height: 100%;
	overflow-y: scroll;
	overflow-x: hidden;
	display: grid;
	grid-template-columns: 1fr;
	grid-gap: 16px;

	::-webkit-scrollbar {
		width: 4px;
	}

	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	::-webkit-scrollbar-thumb {
		background: #888;
	}

	::-webkit-scrollbar-thumb:hover {
		background: #555;
	}
`;

export const DescriptionText = styled.p`
	align-items: center;
	color: #64778f;
	text-align: left;
	padding: 0 10px;
`;

export const CompanyTitle = styled.span`
	font-weight: 500;
`;

export const CardList = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 25px;
	margin-bottom: 16px;
`;

export const Footer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	gap: 20px;
`;

export const CardContent = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	padding: 6px;
`;

export const ActionContainer = styled.div`
	display: grid;
	grid-template-columns: 30px 1fr 24px;

	input {
		height: 20px;
	}
`;

export const TitleType = styled.p`
	font-weight: 600;
	font-size: 12px;
	line-height: 16px;
	color: #64778f;
	text-align: left;
	margin-left: 8px;
`;

export const FormName = styled.p`
	font-weight: 600;
	font-size: 16px;
	line-height: 22px;
	color: #64778f;
	text-align: left;
	margin-left: 8px;
`;

export const FormDescription = styled.p`
	font-weight: 500;
	font-size: 12px;
	line-height: 18px;
	color: #64778f;
	text-align: left;
	margin: 4px 0 0 4px;
	max-height: 76px;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const Wrapper = styled.div`
	position: relative;
`;

export const WarningText = styled.p``;

export const WarningAction = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin-top: 30px;
`;

export const Modal = styled.div`
	position: relative;
`;

export const ContainerModal = styled.div`
	position: absolute;
	bottom: 40vh;
	margin: auto;
	left: 0;
	right: 0;
	text-align: center;
	z-index: 1210;
	background-color: #fff;
	padding: 20px;
	border-radius: 8px;
`;

export const Backdrop = styled.div`
	z-index: 1200;
	top: -90vh;
	right: -50vw;
	position: absolute;
	width: 150vw;
	height: 150vh;
	background-color: rgba(0, 0, 0, 0.6);
`;

export const ErrorCheckbox = styled.p`
	color: tomato;
	text-align: left;
	font-size: 10px;
	margin-left: 4px;
`;
